/******************************  Product Table Block ****************************/ 

wp.blocks.registerBlockType('product-table/wcpt-product-table', {
    title: wp.i18n.__( 'Product Table' ),
    description: wp.i18n.__( 'Product Tables will render.' ),
	icon: "editor-table",
    category: 'common',	    
	attributes: {
		id: {
			type: 'string'
		}
	},  
	edit: function( props ) {
    
        var attributes = props.attributes;
        var setAttributes = props.setAttributes;

        
        var onChangetable = function( event ) {            
            setAttributes( { id: event } );
        };

        
       return wp.element.createElement( wp.components.SelectControl, {        
            label: "Select Product Table",
            value: attributes.id,
            className: 'wcpt-product-table-select',
            options: wcpt_gutenberg.product_tables,
            onChange: onChangetable
    	});
    },

    save: function() {
        // This block doesn't have a front-end save, so return null
        return null;
    }
});



/******************************  Qucik Order Table Block ****************************/ 



wp.blocks.registerBlockType('quick-order/wcpt-quick-order-table', {
    title: wp.i18n.__( 'Quick Order Form' ),
    description: wp.i18n.__( 'Quick Order Form will render.' ),
	icon: "cart",
    category: 'common',	    
	attributes: {
		id: {
			type: 'string'
		}
	},  
	edit: function( props ) {
        
        var attributes = props.attributes;
        var setAttributes = props.setAttributes;

        var onChangetable = function( event ) {            
            setAttributes( { id: event } );
        };

       return wp.element.createElement( wp.components.SelectControl, {        
            label: "Select Quick Order Form",
            value: attributes.id,
            className: 'wcpt-quick-order-table-select',
            options: wcpt_quick_gutenberg.quick_order_tables,
            onChange: onChangetable
    	});
    },

    save: function() {
        // This block doesn't have a front-end save, so return null
        return null;
    }
});